import { Directive, Input, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { UserState } from 'src/app/states/user.state';
import { switchMap } from 'rxjs/operators';
type Type = 'Edit' | 'Create' | 'Read' | 'Delete' | 'All';
const GrantedEnable: Type[] = ['Edit', 'Create', 'Delete', 'All'];

@Directive({
  selector: '[appValidatePermission]'
})
export class ValidatePermissionDirective implements AfterViewInit, OnDestroy {
  @Input("access") access: Type[] = [];
  @Input("hide") hide = true;
  @Input("route") route: string = "";
  @Input("lockClick") lockClick = false;
  subs: Subscription;

  constructor(
    private store: Store,
    private elementRef: ElementRef,
  ) { }

  ngAfterViewInit(): void {
    this.subs = this.store
      .select(UserState.submodules)
      .pipe(
        switchMap<any, any>(() => this.store.select(UserState.route(this.route)))
      ).subscribe(permissions => {
        if (permissions) {
          if (this.hide) {
            this.elementRef.nativeElement.style.display = "none";
          }
          const grantedTo = Object.keys(permissions) as Type[]
          let disabled = true;
          let display = 'none';
          if (grantedTo.some(g => this.access.includes(g))) {
            display = "block";
          }
          if (grantedTo.some(g => GrantedEnable.includes(g))) {
            disabled = false;
          }
          if (this.lockClick) {
            disabled = true;
          }
          if (this.hide) {
            this.elementRef.nativeElement.style.display = display;
          }
          this.elementRef.nativeElement.disabled = disabled;
        }
      });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
